import React from 'react';
import '../../news-pages.css'
import Parse from 'html-react-parser'

import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'


import pic1 from './pic1.jpg'
import pic2 from './pic2.jpg'
import pic3 from './pic3.jpg'
import pic4 from './pic4.jpg'
import pic5 from './pic5.jpg'
import cover from './cover.jpg'


const Page = () => {

    const detail = 
        {
            id:1,
            imgSrc:cover,
            ini:'the Franco-Thai Symposium on Higher Education, Research and Innovation',
            href:'',
            element:'',
            topic:'',
            inform: `Lucent International Collaboration and IJL PRESTO were pleased to participate in the Franco-Thai Symposium on Higher Education, Research and Innovation, held on May 14, 2026, at Centara Grand at Central Plaza Ladprao, Bangkok. Represented by Asst. Prof. Dr. Woottichai Khamduang and Dr. Dorothée Misse, our team joined this important event organized by the French Embassy in Thailand in partnership with Thailand’s Ministry of Higher Education, Science, Research and Innovation (MHESI). The symposium provided a valuable platform to strengthen strategic cooperation between France and Thailand in higher education, science, research, and innovation, while promoting shared approaches to major global challenges. We are honored to be part of this meaningful initiative, which also contributes to the celebration of the 170th anniversary of diplomatic relations between Thailand and France in 2026.`,
            link1: `https://www.facebook.com/permalink.php?story_fbid=pfbid02Epw8QnY1QadV7W2di8X8eKgzBtmzR7t15Si3NPpFZqVHFUgYqibiMMNBD8TG8wiNl&id=100089824854973`,
        }
    
        const handleLink1 = () =>{
            window.open(detail.link1, '_blank', 'noreferrer')
        }

    const imgs = [
        
        {
            imageSrc: cover,
            alt: 'cover',
            title: 'cover',
            thumbnailImageSrc: cover
        },
        {
            imageSrc: pic1,
            alt: 'pic1',
            title: 'pic1',
            thumbnailImageSrc: pic1
        },
        {
            imageSrc: pic2,
            alt: 'pic2',
            title: 'pic2',
            thumbnailImageSrc: pic2
        },
        {
            imageSrc: pic3,
            alt: 'pic3',
            title: 'pic3',
            thumbnailImageSrc: pic3
        },
        {
            imageSrc: pic4,
            alt: 'pic4',
            title: 'pic4',
            thumbnailImageSrc: pic4
        },
        {
            imageSrc: pic5,
            alt: 'pic5',
            title: 'pic5',
            thumbnailImageSrc: pic5
        }
    ]

    return (
        <div className='elements containers'>
            <div className="img-slicer">
                <OwlCarousel
                    className='owl-theme'
                    loop={true}
                    margin={10}
                    lazyLoad={true}
                    nav
                    items={1}
                    autoplay={true}
                    autoplayTimeout={3000}
                    autoplayHoverPause={true}
                    smartSpeed={1000}
                >
                    {imgs.map((img,index)=>(
                        <div className="item" key={index}><img src={img.imageSrc} alt="item" /></div>
                    ))}
                </OwlCarousel>
            </div>
            <div className="text">
                <h1>{detail.ini}</h1>
                <h2>{Parse(detail.topic)}</h2>
                <p>{Parse(detail.inform)}</p>
                <div className="btn">
                    <h2>MORE INFORMATION</h2>
                    <button onClick={handleLink1}>{detail.link1}</button>
                </div>
            </div>
        </div>
    );
}

export default Page;
